import { URLS, PAYMENT_METHODS } from 'common/constants';
import { usePersistedCartData } from 'common/hooks';
import { RenderingRegistry } from 'common/lib/registries';
import { changeRoute } from 'common/utils';
import { useSendCartLink } from 'service/hooks';

const useHandleSendCartLink = () => {
  const [cartData] = usePersistedCartData();

  const isCartAuthorized = cartData ? cartData.isCartAuthorized : false;
  const sendCartLink = useSendCartLink({ isCartAuthorized });

  const handleSendCartLink = async variables => {
    const response: any = await sendCartLink(variables);
    if (response) {
      await changeRoute({ pathname: URLS.SENT_CART_LINK, query: { state: response && PAYMENT_METHODS.ONLINE } });
      window.localStorage.clear();
      RenderingRegistry.clearRegistry();
    }
  };
  return handleSendCartLink;
};
export default useHandleSendCartLink;
